/** Design tokens — dark shell per Figma HOT QUUS (https://share-heat-52178151.figma.site) */
export const figma = {
  cyan: '#37a2d9',
  navy: '#2A4263',
  navyDeep: '#233852',
  /** Primary copy on dark surfaces */
  text: '#e8eef4',
  textMuted: 'rgba(232, 238, 244, 0.72)',
  textMutedLight: 'rgba(232, 238, 244, 0.48)',
  pageBg: '#0b0e12',
  cardBg: '#141a23',
  border: 'rgba(255, 255, 255, 0.12)',
  white: '#ffffff',
  /** Text on light form fields (login, etc.) */
  textOnLight: '#1a1a1a',
} as const;
